import { BreadcrumbItem } from '@/types/services';

export const CONTENTSET_TITLE = 'スクーミーワールドの使い方';
export const BASE_URL = '/hello-schoomy/schoomy-world-guide/s1';

export type PaddingSize = {
    base: number;
    md: number;
    lg: number;
};

export type TutorialItem = {
    code?: number;
    codeBackgroundColor?: string;
    title?: string;
    titleColor?: string;
    description?: string;
    descriptionColor?: string;
    topic?: string;
    topicBackgroundColor?: string;
    topicTextColor?: string;
    image?: ImageItem;
    borderColor?: string;
    button?: ButtonItem;
    bottomPadding?: PaddingSize;
};

export type ImageSize = {
    base: number;
    md: number;
    lg: number;
};

export type ImageItem = {
    imageName: string;
    widths?: ImageSize;
};

export type ButtonItem = {
    title: string;
    titleColor?: string;
    backgroundColor?: string;
    url: string;
};

export type GuideDataItem = {
    contentsUuid: string;
    level: string;
    title: string;
    subTitle: string;
    titleColor: string;
    backgroundColor: string;
    tutorials: TutorialItem[];
};

export const SCHOOMY_WORLD_GUIDE_DATA: readonly GuideDataItem[] = [
    {
        contentsUuid: '8f2d3c9e',
        level: '01',
        title: 'スクーミーワールドにアクセスする',
        subTitle: '仮想空間・メタバース空間『スクーミーワールド』にアクセスします',
        titleColor: '#ffffff',
        backgroundColor: '#F4BB1B',
        tutorials: [
            {
                topic: 'oviceのサービスを活用したメタバースをヴァーチャルオフィスとしています',
                topicBackgroundColor: '#1e90ff',
                topicTextColor: '#ffffff',
                codeBackgroundColor: '#ff7f50',
                description:
                    'こちらのオレンジボタンを押すことで始めることができます。すでにoviceを利用したこのある方は、下のボタンを押すことで会議室にアクセスできます。',
                descriptionColor: '#000',
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                button: {
                    title: 'スクーミーワールドにダイブする',
                    url: 'https://app.ovice.com/ws/schoomyworld/',
                    backgroundColor: '#F4BB1B',
                },
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                borderColor: '#F4BB1B',
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                topic: 'はじめてご利用する方はこちらをご覧ください',
                topicBackgroundColor: '#1e90ff',
                topicTextColor: '#ffffff',
                description:
                    'スクーミ社が用意している仮想空間・メタバース空間『スクーミーワールド』にアクセスすることを『ダイブする』と呼びます。このページでは、スクーミー社の社員メンバーとミーティングをする際にどのようにすればダイブできるのかを説明します。',
                descriptionColor: '#000',
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                topic: '注意',
                topicBackgroundColor: '#ff0000',
                topicTextColor: '#ffffff',
                description:
                    'スクーミーワールドは、GoogleCromeのサービスを利用することを推奨しています。Edgeでは動かない場合もありますので、ご注意してください。もしEdgeで開いている場合は、こちらのURLをコピーして、再度アクセスし直してください。',
                descriptionColor: '#000',
            },
            {
                image: {
                    imageName: 'cb008b92.png',
                    widths: { base: 280, md: 560, lg: 320 },
                },
                bottomPadding: { base: -100, md: -100, lg: -100 },
            },

            {
                title: 'スクーミーワールドは、株式会社スクーミーのオンラインワークスペースとなっております。',
                titleColor: '#1e90ff',
                description:
                    'このページでは、ミーティング時にスクーミーワールドを利用するときのルールとダイブする方法を説明します。',
                descriptionColor: '#000',
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                borderColor: '#F4BB1B',
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                topic: 'スクーミーワールドにダイブする方法',
                topicBackgroundColor: '#1e90ff',
                topicTextColor: '#ffffff',
                description: '下の流れに沿って内容を確認してください',
                descriptionColor: '#000',
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },

            {
                code: 1,
                codeBackgroundColor: '#1e90ff',
                title: '下部にあるビジターとして続行を押してください',
                titleColor: '#1e90ff',
                description: 'すでにoviceのアカウントを持っている場合は、メールアドレスでログインしてください。',
                descriptionColor: '#000',
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                image: {
                    imageName: '587c5792.png',
                    widths: { base: 280, md: 560, lg: 320 },
                },
                bottomPadding: { base: -100, md: -100, lg: -100 },
            },

            {
                code: 2,
                codeBackgroundColor: '#1e90ff',
                title: '名前を設定してください',
                titleColor: '#1e90ff',
                description:
                    '打ち合わせ時に、名前の指定させていただく場合がございますが、原則、所属・担当者名がわかるものにしてください。',
                descriptionColor: '#000',
                bottomPadding: { base: -100, md: -100, lg: -100 },
            },

            {
                description:
                    '※こちらが指定した名前でない場合は、アクセスを拒否させていただく場合がございます。名前の設定を各種チェックポイントにチェックをつけていただき、完了したら【次へ】を押します。',
                descriptionColor: '#000',
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                image: {
                    imageName: 'afe7ee09.png',
                    widths: { base: 280, md: 560, lg: 320 },
                },
                bottomPadding: { base: -100, md: -100, lg: -100 },
            },

            {
                code: 3,
                codeBackgroundColor: '#1e90ff',
                title: 'カメラとマイクの設定をします',
                titleColor: '#1e90ff',
                description:
                    '推奨環境は、GoogleCromeが入っている端末（PCやタブレット）です。EdgeやSafariなどといったサービスでは起動しない場合がありますので注意してください',
                descriptionColor: '#000',
                bottomPadding: { base: -100, md: -100, lg: -100 },
            },
            {
                description:
                    'GoogleCromeでアクセスすると下記のような画面になり、マイクとビデオの設定になります。基本的に左上・右上にポップアップが出てくる場合はそちらの許可をおせば設定できます。',
                descriptionColor: '#000',
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                image: {
                    imageName: 'd25f23cc.png',
                    widths: { base: 280, md: 560, lg: 320 },
                },
            },
            {
                code: 4,
                codeBackgroundColor: '#1e90ff',
                title: 'すべての設定が完了したら次に進んでください',
                titleColor: '#1e90ff',
                description: 'カメラやマイクが設定できていない場合は、アクセスすることができないので注意してください。',
                descriptionColor: '#000',
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                image: {
                    imageName: '593625f3.png',
                    widths: { base: 280, md: 560, lg: 320 },
                },
            },
            {
                code: 5,
                codeBackgroundColor: '#1e90ff',
                title: '会議室に入室しましょう',
                titleColor: '#1e90ff',
                description: 'マイクONで入室いただきます',
                descriptionColor: '#000',
                bottomPadding: { base: 40, md: 40, lg: 40 },
            },
            {
                image: {
                    imageName: '2b149e63.png',
                    widths: { base: 280, md: 560, lg: 320 },
                },
                bottomPadding: { base: -100, md: -100, lg: -100 },
            },
            {
                image: {
                    imageName: 'bdefbd8f.png',
                    widths: { base: 280, md: 560, lg: 720 },
                },
            },

            {
                description: '画面下のメニューバーで、ミュートの解除・・カメラの設定・画面共有の設定を行います',
                descriptionColor: '#000',
                bottomPadding: { base: -100, md: -100, lg: -100 },
            },

            {
                description: '上記内容を確認することができたら下のボタンを押してください',
                descriptionColor: '#000',
            },
            {
                button: {
                    title: 'スクーミーワールドにダイブする',
                    url: 'https://app.ovice.com/ws/schoomyworld/',
                    backgroundColor: '#F4BB1B',
                },
            },
        ],
    },
];

export const BREADCRUMB_SCHOOMY_WORLD_GUIDE_ITEMS: Record<string, BreadcrumbItem[]> = {
    [BASE_URL]: [{ label: `${CONTENTSET_TITLE} 目次` }],
    ...Object.fromEntries(
        SCHOOMY_WORLD_GUIDE_DATA.map((item) => [
            `${BASE_URL}/${item.contentsUuid}`,
            [{ label: CONTENTSET_TITLE, href: BASE_URL }, { label: item.title }],
        ]),
    ),
};
